export default __webpack_public_path__ + "static/media/Diamond.36e074ee.svg";